if (document.readyState == 'complete') {
  initHorizontalScroll();
} else {
  window.addEventListener('load', function () {
    initHorizontalScroll();
  });
}

//debounce function to limit the rate at which a function can fire.
function debounce(func, delay) {
  let timeoutId;
  return function () {
    const args = arguments;
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func.apply(this, args), delay);
  };
}

function initHorizontalScroll() {
  //only proceed if horizontal tabs component is present
  const horizontalTabsComponent = document.querySelectorAll(
    '.mhecomm-horizontaltabs,.mhecomm-producttabs,.mhecomm-he-producttabs .tabs-container'
  );
  const horizontalTabsArray = horizontalTabsComponent ? Array.from(horizontalTabsComponent) : [];
  if (!horizontalTabsArray || horizontalTabsArray.length === 0) {
    return;
  }

  horizontalTabsArray.forEach((componentContainer) => {
    const { mainContainer, tabList } = getTabsFromContainer(componentContainer);
    if (!mainContainer || !tabList) {
      return;
    }

    updateScrollButtons(mainContainer, tabList);

    addScrollListener(mainContainer, tabList);

    addClickListeners(mainContainer, tabList);
  });

  //resize / zoom scenario
  const debouncedResize = debounce(() => {
    horizontalTabsArray.forEach((componentContainer) => {
      const { mainContainer, tabList } = getTabsFromContainer(componentContainer);
      if (!mainContainer || !tabList) {
        return;
      }
      updateScrollButtons(mainContainer, tabList);
    });
  }, 100);

  window.removeEventListener('resize', debouncedResize);
  window.addEventListener('resize', debouncedResize);
}

//function to add click listeners to scroll buttons
function addClickListeners(mainContainer, tabList) {
  //add click listeners to scroll buttons
  const leftScrollBtn = mainContainer.querySelector('.scroll-left');
  if (leftScrollBtn) {
    leftScrollBtn.addEventListener('click', () => {
      scrollClickHandler(mainContainer, tabList, 'left');
    });
  }
  const rightScrollBtn = mainContainer.querySelector('.scroll-right');
  if (rightScrollBtn) {
    rightScrollBtn.addEventListener('click', () => {
      scrollClickHandler(mainContainer, tabList, 'right');
    });
  }
}

function scrollClickHandler(mainContainer, tabList, direction) {
  const scrollAmount = direction === 'left' ? -100 : 100;
  tabList.scrollBy({
    left: scrollAmount,
    behavior: 'smooth',
  });
  // Update button state after scrolling
  setTimeout(() => updateScrollButtons(mainContainer, tabList), 300);
}

//function to show/hide scroll buttons based on position
function updateScrollButtons(mainContainer, tabList) {
  // Show/hide left scroll button
  const leftScrollBtn = mainContainer.querySelector('.scroll-left');
  //Show/hide right scroll button
  const rightScrollBtn = mainContainer.querySelector('.scroll-right');

  if (!leftScrollBtn || !rightScrollBtn) {
    return;
  }

  const bufferFractionalPixels = 5;
  const scrollState = getScrollState(tabList, bufferFractionalPixels);

  // Update container class
  if (scrollState.isScrollable) {
    mainContainer.classList.add('has-scroll-buttons');
  } else {
    mainContainer.classList.remove('has-scroll-buttons');
  }

  if (scrollState.canScrollLeft) {
    //show left button
    leftScrollBtn.classList.remove('d-none');
  } else {
    //hide left button
    leftScrollBtn.classList.add('d-none');
  }

  if (scrollState.canScrollRight) {
    rightScrollBtn.classList.remove('d-none');
  } else {
    rightScrollBtn.classList.add('d-none');
  }
}
//add scroll for tablist
function addScrollListener(mainContainer, tabList) {
  tabList.addEventListener(
    'scroll',
    debounce(() => {
      updateScrollButtons(mainContainer, tabList);
    }, 100)
  );
}

function getScrollState(tabList, bufferFractionalPixels) {
  const isScrollable = tabList.scrollWidth > tabList.clientWidth + bufferFractionalPixels;

  const canScrollLeft = tabList.scrollLeft > bufferFractionalPixels;

  const canScrollRight =
    Math.ceil(tabList.scrollLeft + tabList.clientWidth) < tabList.scrollWidth - bufferFractionalPixels;

  return { isScrollable: isScrollable, canScrollLeft: canScrollLeft, canScrollRight: canScrollRight };
}

function getTabsFromContainer(componentContainer) {
  //<ul> tab container
  const mainContainer = componentContainer.querySelector('.tabs-container');
  const tabList = mainContainer.querySelector('ul.nav-tabs');
  if (!tabList || tabList.length === 0) {
    return null;
  }
  return { mainContainer: mainContainer, tabList: tabList };
}
